


import PPromise from 'p-progress';
import { ISiteData } from './interface';
import { IZip, IFetcher, IFetchRequest, Method, ResponseTypes, IFetchResponse, injectFetch, injectZip } from '../../interface/util';

function _request(apiUrl: string, apiExtension: string, authToken: string, hash: string) : IFetchRequest {
    const req = {
        url: apiUrl + apiExtension,
        method: 'POST' as Method,
        headers: [
            { name:'Authorization', value: `Bearer ${authToken}` },
            { name:'Content-Type', value: 'application/json' },
        ],
        body: JSON.stringify({'hash':hash}),
        expectedResponseType: 'blob' as ResponseTypes,
    };
    return req;
}

function _downloadSiteData(fetcher: IFetcher, apiUrl: string, apiExtension: string, authToken: string, hash: string = "", timeout = (20 * 10000)): PPromise<Blob> {
    return new PPromise(function(resolve, reject, progress) {
        const req = _request(apiUrl, apiExtension, authToken, hash);
        const promise = fetcher<Blob>(req, timeout)
        promise.onProgress(function(data) {
                progress(data)
            })
        promise.then(function(response: IFetchResponse<Blob>) {
                if ( !response.payload ) {
                    reject('Missing payload from response');
                }

                const blob = new Blob([response.payload as Blob]);

                resolve(blob)
            })
            .catch(function(err) {
                reject(err);
            })
    });
}

function _unzipSiteData(zip: IZip, blob: Blob): PPromise<ISiteData> {
    return new PPromise(function(resolve, reject, progress) {
        zip.unzipFile<string>(blob, 'data.json')
            .then(function(dataStr) {
                progress(1.0);
                const jsonData = JSON.parse(dataStr) as ISiteData;
                resolve(jsonData);
            })
            .catch(function(err) {
                reject(err);
            });
    });
}

function getSiteData(apiUrl: string, apiExtension: string, authToken: string, hash: string = "", timeout= (20 * 10000)): PPromise<ISiteData> {
  
    return new PPromise(async function(resolve, reject, progress) {
        const fetcher = await injectFetch();
        const zip = await injectZip();
        
        const promise = _downloadSiteData(fetcher, apiUrl, apiExtension, authToken, hash, timeout)

        promise.onProgress(function(data) {
            progress(data/2); /* 2 Jobs */                
        })

        promise
            .then(blob => _unzipSiteData(zip, blob))
            .then(sitedata => resolve(sitedata))
            .catch(err => reject(err));
    });
}

export default getSiteData;